import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";

const ScrobitsLogo = "/assets/img/logo.svg";
const linkedinLogo = "/assets/img/footer/linkedin.webp";
const faceBookLogo = "/assets/img/footer/facebook.webp";
const InstagramLogo = "/assets/img/footer/instagram.webp";
const twitterLogo = "/assets/img/footer/twitter.webp";

const Footer = () => (
  <div className="scrobits__footer section__padding">
    <div className="scrobits__footer-links">
      <div className="scrobits__footer-links_logo">
        <img src={ScrobitsLogo} alt="scrobits_logo" />
        <p>
          Bandal Dhankude Plaza
          <br />
          Kothrud Pune-411038
          <br />
          India.
        </p>
      </div>
      <div className="scrobits__footer-links_div">
        <h4>Social Handles</h4>
        <div className="logo-section">
          {/* <div className="footer-logo-img"></div> */}
          <a
            href="https://www.linkedin.com/company/scrobits-technologies/?originalSubdomain=in"
            target="blank"
          >
            <img
              className="footer-logo-img "
              src={linkedinLogo}
              href="/www.scrobits.com"
            />
          </a>
          <a
            style={{ marginLeft: "5%" }}
            href="https://www.instagram.com/scrobits_technologies/"
            target="blank"
          >
            <img className="footer-logo-img " src={InstagramLogo} />
          </a>
          <a
            style={{ marginLeft: "5%" }}
            href="https://twitter.com/scrobitstech"
            target="blank"
          >
            <img className="footer-logo-img " src={twitterLogo} />
          </a>
          <a
            style={{ marginLeft: "5%" }}
            href="https://www.facebook.com/scrobitstechnologies/"
            target="blank"
          >
            <img className="footer-logo-img " src={faceBookLogo} />
          </a>
        </div>
      </div>
      <div className="scrobits__footer-links_div">
        <h4>Links</h4>
        <p>
          <a href="/#about-scrobits">About Us</a>
        </p>
        <p>
          <a href="/#services">Services</a>
        </p>
        <p>
          <a href="/#contact-us">Contact</a>
        </p>
        <p>
          <a href="/#career">Join Us</a>
        </p>
        <p>
          <a href="/get-started">Get Quote</a>
        </p>
      </div>

      <div className="scrobits__footer-links_div">
        <h4>Get in touch</h4>
        <p>Our door is always open for a good cup of coffee.</p>
        <p>Call: (+91) 8329556130/ 7020818025</p>
        <a href="mailto: contact@scrobits.com?subject = Enquiry&body = Remove this text">
          <p>Mail: contact@scrobits.com</p>
        </a>
      </div>
    </div>

    <div className="scrobits__footer-copyright">
      <p>&copy; 2021 ScroBits Technologies All rights reserved.</p>
      <p>
        <Link to="/sitemap">SiteMap</Link>
      </p>
    </div>
  </div>
);

export default Footer;
